import { render, staticRenderFns } from "./ShareLinkSetup.vue?vue&type=template&id=52b66e97&scoped=true"
import script from "./ShareLinkSetup.vue?vue&type=script&lang=js"
export * from "./ShareLinkSetup.vue?vue&type=script&lang=js"
import style0 from "./ShareLinkSetup.vue?vue&type=style&index=0&id=52b66e97&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52b66e97",
  null
  
)

export default component.exports